import { useState } from "react";
import { faqs } from "@/mocks/gossip";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState<number | null>(0);

  return (
    <section id="faq" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-4xl px-4 md:px-6">
        <div className="text-center">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-secondary-300 bg-secondary-100 px-3 py-1 text-[11px] font-medium text-secondary-900">
            <i className="ri-question-line"></i> 吃瓜须知
          </span>
          <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            常见问题 FAQ
          </h2>
          <p className="mx-auto mt-2 max-w-xl text-sm text-foreground-500">
            关于投稿、求证、删帖与平台定位，先看这里再上墙。
          </p>
        </div>

        <div className="mt-10 space-y-3">
          {faqs.map((f, i) => {
            const open = openIdx === i;
            return (
              <div
                key={f.q}
                className={`overflow-hidden rounded-2xl border transition ${
                  open
                    ? "border-primary-200 bg-background-50 shadow-soft"
                    : "border-background-200 bg-background-100/50"
                }`}
              >
                <h3>
                  <button
                    type="button"
                    onClick={() => setOpenIdx(open ? null : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-3 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3 text-sm font-semibold text-foreground-900 md:text-base">
                      <span
                        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                          open ? "bg-primary-500 text-background-50" : "bg-background-200 text-foreground-600"
                        }`}
                      >
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      {f.q}
                    </span>
                    <i
                      className={`ri-arrow-down-s-line shrink-0 text-lg text-foreground-400 transition-transform ${
                        open ? "rotate-180 text-primary-600" : ""
                      }`}
                    ></i>
                  </button>
                </h3>
                {open && (
                  <div className="px-5 pb-5 md:px-6">
                    <p className="ml-10 border-l-2 border-accent-200 pl-4 text-sm leading-relaxed text-foreground-600">
                      {f.a}
                    </p>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}